import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";

const fitSize = (font, text, maxWidth, startSize, minSize) => {
  let size = startSize;
  while (size > minSize && font.widthOfTextAtSize(text, size) > maxWidth) size -= 0.5;
  return size;
};

export async function generateWertePdf(values) {
  const [tplBytes, lightBytes, mediumBytes] = await Promise.all([
    fetch("/werte-vorlage.pdf").then((r) => r.arrayBuffer()),
    fetch("/fonts/catamaran-light.ttf").then((r) => r.arrayBuffer()),
    fetch("/fonts/catamaran-medium.ttf").then((r) => r.arrayBuffer()),
  ]);
  const pdf = await PDFDocument.load(tplBytes);
  pdf.registerFontkit(fontkit);
  const light = await pdf.embedFont(lightBytes, { subset: true });
  const medium = await pdf.embedFont(mediumBytes, { subset: true });
  const page = pdf.getPage(0);
  const mb = page.getMediaBox();
  const Y = (topCoord) => mb.y + mb.height - topCoord;
  const white = rgb(1, 1, 1);
  const black = rgb(0, 0, 0);

  const valuesText = `${values[0]}, ${values[1]}, ${values[2]} und ${values[3]}`;
  page.drawRectangle({ x: 172, y: Y(245.5), width: 372, height: 27.5, color: white });
  const vSize = fitSize(medium, valuesText, 541 - 180, 14, 8.5);
  page.drawText(valuesText, { x: 180, y: Y(236.3), size: vSize, font: medium, color: black });

  const qBaselines = [287.6, 410.9, 534.0, 657.5];
  values.forEach((v, i) => {
    const txt = `Was bedeute ${v} für Dich persönlich? Wie definierst Du ${v}?`;
    page.drawRectangle({ x: 50, y: Y(qBaselines[i] + 7), width: 498, height: 23.5, color: white });
    const s = fitSize(light, txt, 541 - 53.9, 12, 9);
    page.drawText(txt, { x: 53.9, y: Y(qBaselines[i]), size: s, font: light, color: black });
  });

  const bytes = await pdf.save();
  const blob = new Blob([bytes], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Meine-4-Kernwerte.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
